/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import * as Msdyn365 from '@msdyn365-commerce/core';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICheckoutSectionContainerItem, ICheckoutSectionContainerViewProps } from './checkout-section-container-w-payment-selector';
import { get } from 'lodash';

const ItemComponent: React.FC<ICheckoutSectionContainerItem> = ({ loading, itemProps, item }) => (
    <>
        {loading}
        <Node {...itemProps}>{item}</Node>
    </>
);

const renderCcFeeMessage = (ccSurchargeFreeMessage: Msdyn365.RichText) => {
    return (
        <Msdyn365.RichTextComponent
            text={ccSurchargeFreeMessage}
            className='checkout-section-container-w-payment-selector__cc-processing-fee'
        />
    );
};

const CheckoutSectionContainerView: React.FC<ICheckoutSectionContainerViewProps> = ({
    checkoutPlainContainerProps,
    items,
    renderSelectorButtons,
    renderSelectPaymentLink,
    selectedPaymentMethod,
    config: { ccSurchargeFreeMessage },
    resources: { payByText },
    moduleState,
    renderSaveButton,
    checkoutSectionContainerModuleProps
}) => {
    const isSaveButtonHidden = moduleState.childIds.some(childId => {
        const state = moduleState.getModule(childId);
        return !!state?.isReady;
    });

    let tenderName: string | undefined;
    if (React.isValidElement(renderSelectorButtons)) {
        tenderName = get(renderSelectorButtons, 'props.children[0].props.paymentTenderType.tenderName', undefined);
    }

    return (
        <Node {...checkoutSectionContainerModuleProps}>
            {ccSurchargeFreeMessage && tenderName !== 'On Account' && renderCcFeeMessage(ccSurchargeFreeMessage)}
            {selectedPaymentMethod && (
                <div className='checkout-section-container-w-payment-selector__selector'>
                    <div className='checkout-section-container-w-payment-selector__tender-name'>
                        {payByText} {selectedPaymentMethod?.tenderName}
                    </div>
                    {renderSelectPaymentLink}
                </div>
            )}
            {renderSelectorButtons}
            <Module {...checkoutPlainContainerProps}>
                {items.map(item => (
                    <ItemComponent key={item.id} {...item} />
                ))}
            </Module>
            <div
                className={`checkout-section-container-w-payment-selector__container ${
                    isSaveButtonHidden ? 'checkout-section-container-w-payment-selector--hide-save-button' : ''
                }`}
            >
                {renderSaveButton}
            </div>
        </Node>
    );
};

export default CheckoutSectionContainerView;
